require('../../../libs/backbone/backbone.ajaxq.adapter.ts');
var GenericView = require('../generic.view.ts');

var Handlebars = require('handlebars');
var HandlebarsHelpers = require('../../../libs/handlebars/handlebars-helpers.ts');

var Template = require('text-loader!../../templates/tickets/queueState.template.html');

var Collection = require('../../models/tickets.paginated.collection.ts');

require('../../../libs/bootstrap/js/bootstrap-table.js');

var i18n = require("l10n");

var TheView = GenericView.extend({
    tagName: 'div',
    className: 'queueState',
	progressTemplate: Handlebars.compile("{{> progressPartial}}"),
	template: Handlebars.compile(Template),
	queueStateStompSubscription: null,
	initialize: function (options) {
		var self = this;

        this.model = options ? options.model : null;
        this.wsocket = options ? options.wsocket : null;
        this.client = options ? options.client : null;

        /*this.unsubscribeStomp();
        this.subscribeToStomp();

        $(window).off("tickets:closed").on("tickets:closed", function() {
            self.unsubscribeStomp();
        });*/
	},
	superRender:  GenericView.prototype.render,
	render: function () {
		this.superRender();

		this.$el.html( this.template(this.model) );

		return this;
	},
	events: {
	    "change .toggleBlockCheckbox": "toggleBlockCheckbox"
	},
	unsubscribeStomp: function() {
	    if(this.queueStateStompSubscription) {
	        this.queueStateStompSubscription.unsubscribe();
            this.queueStateStompSubscription = null;
	    }
	},
	subscribeToStomp: function() {
	    if(this.queueStateStompSubscription != null) // already subscribed
	        return;

        var self = this;

        this.queueStateStompSubscription = this.client.subscribe('/live/admin/queueStatus/'+ this.model.id, function (message){
            var responseObject = JSON.parse( message.body );

            self.model.queueState = responseObject.queueState;
            self.render();
        });
    },
    toggleBlockCheckbox: function(e) {
        var $elem = $(e.currentTarget);
        var isToSuspend = $elem.attr("checked") != "checked"; // retrieves current state (before clicking it)

        var self = this;

        $.ajaxDefaultQ({
            url:  "/rest/api/admin/queueStatus/" + this.model.id,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify( isToSuspend )
        }).done(function(response, status, xhr){
            if(status == "success") {
                if(response.data && response.data) {
                    self.model.queueState = response.data;
                    self.render();
                }
                else {
                    self.render();
                    self.showErrorMessage();
                }
            }
            else {
                console.error("Error while getting queue status for Queue ("+ self.model.id +")");
                self.render();
                self.showErrorMessage();
            }
        })
        .fail(function(response) {
            console.error("Error while getting appointments for Queue ("+ self.model.id +")", response);
            self.render();
            self.showErrorMessage();
        });
    },
    showErrorMessage: function() {
        this.$el.find("customSwitchCheckbox").notify(i18n.t("server.errorOccurred"), { position:"left center", className: "error" });
    }
});

module.exports = TheView;